import * as React from "react";
import type { SVGProps } from "react";
const SvgMinimizeRisk = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="m57.875 47.676-21.939-38c-1.749-3.03-6.123-3.03-7.872 0l-21.939 38c-1.75 3.03.438 6.817 3.936 6.817H53.94c3.499 0 5.686-3.787 3.936-6.817ZM37.452 8.8c-2.423-4.196-8.48-4.196-10.903 0l-21.94 38c-2.422 4.197.606 9.442 5.452 9.442H53.94c4.846 0 7.875-5.245 5.452-9.442l-21.94-38Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      d="M32 17.52a1.99 1.99 0 0 1 1.99 2.017l-.246 18.355a1.744 1.744 0 0 1-3.488 0l-.247-18.355a1.99 1.99 0 0 1 1.99-2.018Zm0 30.979c-.732 0-1.36-.266-1.884-.796a2.616 2.616 0 0 1-.787-1.906c0-.74.262-1.376.787-1.906.524-.53 1.152-.796 1.884-.796s1.36.265 1.884.796c.524.53.786 1.166.786 1.906 0 .49-.123.94-.37 1.35-.238.411-.56.741-.965.991-.396.24-.84.36-1.335.36Z"
    />
    <path
      fill="#D3ECF8"
      d="M64 49.033c0 6.49-5.261 11.75-11.751 11.75-6.49 0-11.751-5.26-11.751-11.75s5.261-11.751 11.75-11.751c6.49 0 11.752 5.261 11.752 11.75Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M52.249 59.034c5.523 0 10-4.478 10-10.001s-4.477-10.001-10-10.001-10.001 4.478-10.001 10c0 5.524 4.478 10.002 10 10.002Zm0 1.75c6.49 0 11.75-5.261 11.75-11.751 0-6.49-5.26-11.751-11.75-11.751s-11.751 5.261-11.751 11.75c0 6.49 5.261 11.752 11.75 11.752Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M52.277 42.74c.474 0 .858.384.858.858v10l2.517-2.28a.859.859 0 0 1 1.153 1.273l-4.524 4.1-4.582-4.097a.859.859 0 0 1 1.144-1.28l2.575 2.302V43.598c0-.474.384-.858.859-.858Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgMinimizeRisk;
